import { useLocalStorage } from './useStorage';
import * as translations from '../Translations';

const withParams = (message, params) => {
  let pos = 0;
  return message.split(/{([^}]+)}/).map(msg => {
    if (msg.startsWith('$')) {
      const newMessage = params[pos];
      pos += 1;
      return newMessage || '{Alert: incomplete array values}';
    }
    return msg;
  });
};

const getNestedTranslation = (language, keys) => keys.reduce((obj, key) => obj?.[key], translations[language]);

const useTranslation = (page = '') => {
  const [language, setLanguage] = useLocalStorage('language', 'sp');
  const [fallbackLanguage, setFallbackLanguage] = useLocalStorage('fallbackLanguage', 'sp');

  const translate = (key, params = []) => {
    const keys = key.split('.');
    const text =
      getNestedTranslation(language, keys, params) ?? getNestedTranslation(fallbackLanguage, keys, params) ?? key;
    return params.length === 0 ? text : withParams(text, params);
  };

  const newTranslate = (key, params = []) => {
    const keys = [page, key];
    const text =
      getNestedTranslation(language, keys, params) ?? getNestedTranslation(fallbackLanguage, keys, params) ?? key;
    return params.length === 0 ? text : withParams(text, params);
  };

  return {
    language,
    setLanguage,
    fallbackLanguage,
    setFallbackLanguage,
    t: translate,
    t2: newTranslate,
  };
};

export default useTranslation;
